import React from "react";
import { Select } from "antd";

function MySelect(props) {
  return <Select {...props} />;
}

export default MySelect;
